import i18n from "@/libs/i18n";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/Home",
      name: "Home",
      component: () => import("@/views/Home.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Clients",
      name: "Clients",
      component: () => import("@/views/pages/Clients/Clients.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Owners",
      name: "Owners",
      component: () => import("@/views/pages/Owners/Owners.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Matter",
      name: "Matter",
      component: () => import("@/views/pages/Matter/Matter.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Invoice",
      name: "Invoice",
      component: () => import("@/views/pages/Finance/Invoice.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Payment",
      name: "Payment",
      component: () => import("@/views/pages/Finance/Payment.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/InvoiceDetailReport",
      name: "InvoiceDetailReport",
      component: () => import("@/views/pages/Finance/InvoiceDetailReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Employee",
      name: "Employee",
      component: () => import("@/views/pages/Definitions/Employee.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawClient",
      name: "LawClient",
      component: () => import("@/views/pages/Definitions/LawClient.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawActivity",
      name: "LawActivity",
      component: () => import("@/views/pages/Definitions/LawActivity.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawSubject",
      name: "LawSubject",
      component: () => import("@/views/pages/Definitions/LawSubject.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawDecision",
      name: "LawDecision",
      component: () => import("@/views/pages/Definitions/LawDecision.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterOutcome",
      name: "LawMatterOutcome",
      component: () => import("@/views/pages/Definitions/LawMatterOutcome.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterFileType",
      name: "LawMatterFileType",
      component: () =>
        import("@/views/pages/Definitions/LawMatterFileType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterType",
      name: "LawMatterType",
      component: () => import("@/views/pages/Definitions/LawMatterType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterTypeSubFolder",
      name: "LawMatterTypeSubFolder",
      component: () => import("@/views/pages/Definitions/LawMatterTypeSubFolder.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterStatus",
      name: "LawMatterStatus",
      component: () => import("@/views/pages/Definitions/LawMatterStatus.vue"),
      meta: {
        rule: "logged",
      },
    },
    // {
    //   path: "/LawCourt",
    //   name: "LawCourt",
    //   component: () => import("@/views/pages/Definitions/LawCourt.vue"), //Depricated
    //   meta: {
    //     rule: "logged",
    //   },
    // },
    {
      path: "/CreditNotes",
      name: "CreditNotes",
      component: () => import("@/views/pages/Reports/CreditNotes.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/CancelledInvoice",
      name: "CancelledInvoice",
      component: () => import("@/views/pages/Reports/CancelledInvoice.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/CostAccounting",
      name: "CostAccounting",
      component: () => import("@/views/pages/Reports/CostAccounting.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Vouchers",
      name: "Vouchers",
      component: () => import("@/views/pages/Reports/Vouchers.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/AgingReport",
      name: "AgingReport",
      component: () => import("@/views/pages/Reports/AgingReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/MatterReport",
      name: "MatterReport",
      component: () => import("@/views/pages/Reports/MatterReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/ExpenseReport",
      name: "ExpenseReport",
      component: () => import("@/views/pages/Reports/ExpenseReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/InvoiceCodeReport",
      name: "InvoiceCodeReport",
      component: () => import("@/views/pages/Reports/InvoiceCodeReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawyerDailyworkReport",
      name: "LawyerDailyworkReport",
      component: () =>
        import("@/views/pages/Reports/LawyerDailyworkReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawLawyerInvoiceReport",
      name: "LawLawyerInvoiceReport",
      component: () =>
        import("@/views/pages/Reports/LawLawyerInvoiceReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/DailyworkReport",
      name: "DailyworkReport",
      component: () => import("@/views/pages/Dailywork/DailyworkReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawClientPowerOfAttorneyDeadlineReport",
      name: "LawClientPowerOfAttorneyDeadlineReport",
      component: () =>
        import("@/views/pages/Reports/PowerOfAttorneyReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/ReminderReport",
      name: "ReminderReport",
      component: () => import("@/views/pages/Reminder/ReminderReport.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Account",
      name: "Account",
      component: () => import("@/views/pages/Account/Account.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport",
      name: "LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport",
      component: () =>
        import(
          "@/views/pages/Reports/LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport.vue"
        ),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawDocumentContentType",
      name: "LawDocumentContentType",
      component: () =>
        import("@/views/pages/Definitions/LawDocumentContentType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/Expert",
      name: "Expert",
      component: () => import("@/views/pages/Expert/Expert.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawDailyworkDescription",
      name: "LawDailyworkDescription",
      component: () =>
        import("@/views/pages/Definitions/LawDailyworkDescription.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/StandardInvoiceCodes",
      name: "StandardInvoiceCodes",
      component: () =>
        import("@/views/pages/Definitions/StandardInvoiceCodes.vue"),
      meta: {
        rule: "logged",
      },
    },
    // {
    //   path: "/InvoiceApprovalList",
    //   name: "InvoiceApprovalList",
    //   component: () => import("@/views/pages/Finance/InvoiceApprovalList.vue"), //Depricated
    //   meta: {
    //     rule: "logged",
    //   },
    // },
    {
      path: "/BaseTimer",
      name: "BaseTimer",
      component: () => import("@/layouts/components/BaseTimer.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/RemindingFolders",
      name: "RemindingFolders",
      component: () => import("@/layouts/components/RemindingFolders.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawNoteToBeOnInvoice",
      name: "LawNoteToBeOnInvoice",
      component: () => import("@/views/pages/Definitions/LawNoteToBeOnInvoice.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawLedes",
      name: "LawLedes",
      component: () => import("@/views/pages/Finance/LawLedes.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawPoNumber",
      name: "LawPoNumber",
      component: () => import("@/views/pages/Finance/LawPoNumber.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawLedesCodeType",
      name: "LawLedesCodeType",
      component: () => import("@/views/pages/Definitions/LawLedesCodeType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMatterSubject",
      name: "LawMatterSubject",
      component: () => import("@/views/pages/Definitions/LawMatterSubject.vue"),
      meta:{
         rule: "logged",
      },
    },
    {
      path: "/LawMatterProcessResult",
      name: "LawMatterProcessResult",
      component: () => import("@/views/pages/Definitions/LawMatterProcessResult.vue"),
      meta:{
         rule: "logged",
      },
    },
    {
      path: "/LawMatterSubSubject",
      name: "LawMatterSubSubject",
      component: () => import("@/views/pages/Definitions/LawMatterSubSubject.vue"),
      meta:{
         rule: "logged",
      },
    },
    {
      path: "/LawExpertOpinionOutcome",
      name: "LawExpertOpinionOutcome",
      component: () => import("@/views/pages/Definitions/LawExpertOpinionOutcome.vue"),
      meta:{
         rule: "logged",
      },
    },
    {
      path: "/LawProductCategory",
      name: "LawProductCategory",
      component: () => import("@/views/pages/Definitions/LawProductCategory.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawDamagesClaimType",
      name: "LawDamagesClaimType",
      component: () => import("@/views/pages/Definitions/LawDamagesClaimType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawTradeFairSubject",
      name: "LawTradeFairSubject",
      component: () => import("@/views/pages/Definitions/LawTradeFairSubject.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawTradeFairCenter",
      name: "LawTradeFairCenter",
      component: () => import("@/views/pages/Definitions/LawTradeFairCenter.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawTradeFair",
      name: "LawTradeFair",
      component: () => import("@/views/pages/Definitions/LawTradeFair.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawTypeOfViolation",
      name: "LawTypeOfViolation",
      component: () => import("@/views/pages/Definitions/LawTypeOfViolation.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawProfessionalInvestigationType",
      name: "LawProfessionalInvestigationType",
      component: () => import("@/views/pages/Definitions/LawProfessionalInvestigationType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawSecurityDepositType",
      name: "LawSecurityDepositType",
      component: () => import("@/views/pages/Definitions/LawSecurityDepositType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawProfessionalInvestigationRegion",
      name: "LawProfessionalInvestigationRegion",
      component: () => import("@/views/pages/Definitions/LawProfessionalInvestigationRegion.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawSecurityDepositMethod",
      name: "LawSecurityDepositMethod",
      component: () => import("@/views/pages/Definitions/LawSecurityDepositMethod.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawSecurityDepositClientRefundMethod",
      name: "LawSecurityDepositClientRefundMethod",
      component: () => import("@/views/pages/Definitions/LawSecurityDepositClientRefundMethod.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawCounterParty",
      name: "LawCounterParty",
      component: () => import("@/views/pages/Definitions/LawCounterParty.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawCounterPartyType",
      name: "LawCounterPartyType",
      component: () => import("@/views/pages/Definitions/LawCounterPartyType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawCounterPartySubType",
      name: "LawCounterPartySubType",
      component: () => import("@/views/pages/Definitions/LawCounterPartySubType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawCounterPartyAttorney",
      name: "LawCounterPartyAttorney",
      component: () => import("@/views/pages/Definitions/LawCounterPartyAttorney.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawAuthorityRepresentative",
      name: "LawAuthorityRepresentative",
      component: () => import("@/views/pages/Definitions/LawAuthorityRepresentative.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawAuthorityCategory",
      name: "LawAuthorityCategory",
      component: () => import("@/views/pages/Definitions/LawAuthorityCategory.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawAuthoritySubCategory",
      name: "LawAuthoritySubCategory",
      component: () => import("@/views/pages/Definitions/LawAuthoritySubCategory.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawAuthority",
      name: "LawAuthority",
      component: () => import("@/views/pages/Definitions/LawAuthority.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawAuthorityType",
      name: "LawAuthorityType",
      component: () => import("@/views/pages/Definitions/LawAuthorityType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawEventType",
      name: "LawEventType",
      component: () => import("@/views/pages/Definitions/LawEventType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawMediationResult",
      name: "LawMediationResult",
      component: () => import("@/views/pages/Definitions/LawMediationResult.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/LawLedesType",
      name: "LawLedesType",
      component: () => import("@/views/pages/Definitions/LawLedesType.vue"),
      meta: {
        rule: "logged",
      },
    },
    {
      path: "/",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
        rule: "nonlogin",
      },
    },
    {
      path: "/ForgotPassword",
      name: "ForgotPassword",
      component: () => import("@/views/ForgotPassword.vue"),
      meta: {
        layout: "full",
        rule: "nonlogin",
        adminAuth: true,
        residentAuth: false,
      },
    },
    {
      path: "/ChangePassword",
      name: "ChangePassword",
      component: () => import("@/views/ChangePassword.vue"),
      meta: {
        layout: "full",
        rule: "nonlogin",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
        rule: "nonlogin",
      },
    },
    {
      path: "/exit",
      name: "exit",
      component: () => import("@/views/Exit.vue"),
      meta: {
        layout: "full",
        rule: "nonlogin",
      },
      // redirect: '/'
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("accessToken");
  // to.meta.roles.includes(store.state.user.rol)
  if (to.meta.rule == "nonlogin") {
    next();
  } else if (to.meta.rule == "logged" && loggedIn) {
    const RoleId = localStorage.getItem("RoleId");
    if (to.meta.roleId != undefined) {
      if (to.meta.roleId == RoleId) {
        next();
      } else {
        return next("Unauthorized");
      }
    }
    next();
  } else {
    localStorage.clear();
    return next("/");
  }
});

export default router;
